export default __webpack_public_path__ + "static/media/logo.23869ce4.png";